module.exports = __webpack_public_path__ + "media/images/icon_unite-23fbf04b3a45c110a886749f3c4a65f6.png";